<template>
  <div>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha:</label>
        <CInput
          :value.sync="$v.form.fechahora.$model"
          :isValid="checkIfValid('fechahora')"
          type="datetime-local"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
        <p class="info_text">
          Selecione el día que está realizando el registro del documento
        </p>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Trabajador:</label>
        <vSelectC
          v-model="form.trabajador_id"
          :options="trabajadores"
          class="margin-multi"
          :loading="isLoadingPage"
          placeholder="Selecciona un trabajador"
        >
          <template #open-indicator="{ attributes }">
            <CIcon
              v-bind="attributes"
              class="cursor-p"
              name="cil-caret-bottom"
            />
          </template>
        </vSelectC>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Evento:</label>
        <vSelectC
          v-model="form.evento"
          :options="eventos"
          class="margin-multi"
          :loading="isLoadingPage"
          placeholder="Selecciona un evento"
        >
          <template #open-indicator="{ attributes }">
            <CIcon
              v-bind="attributes"
              class="cursor-p"
              name="cil-caret-bottom"
            />
          </template>
        </vSelectC>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import eventos from "../views/operaciones/asistencias/eventos.json";

export default {
  mixins: [validationMixin],
  validations: {
    form: {
      fechahora: {
        required,
      },
      evento: {
        required,
      },
      trabajador_id: {
        required,
      },
    },
  },
  data() {
    return {
      eventos,

      form: {
        fechahora: "",
        evento: "",
        trabajador_id: null,
      },
    };
  },
  created() {
    this.$emit("handledSubmit", this.handledSubmit);
    this.$emit("setData", this.setData);
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    isValidFechahora() {
      return !this.$v.form.fechahora.$invalid;
    },
    isValidEvento() {
      return !this.$v.form.evento.$invalid;
    },
    isValidTrabajadorId() {
      return !this.$v?.form.trabajador_id.$invalid;
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateAsistencia() {
      this.$v.form.fechahora.$touch();
      this.$v.form.evento.$touch();
      this.$v.form.trabajador_id.$touch();
    },
    handledSubmit() {
        debugger
      this.validateAsistencia();

      if (
        this.isValidFechahora &&
        this.isValidEvento &&
        this.isValidTrabajadorId
      ) {
        this.isLoading = true;
        return {
          schema: "asistencias",
          payload: {
            encabezado: {
              fechahora: moment(this.form.fechahora).format("YYYY-MM-DD HH:mm:ss"),
              trabajador_id: this.form.trabajador_id && this.form.trabajador_id.value,
              evento: this.form.evento && this.form.evento.value,
              ubicacion_raiz_id: this.ubicacionRaiz
                ? this.ubicacionRaiz.value
                : null,
            },
          },
        };
      }
      return { skip: true };
    },
    setData(data) {
      Object.assign(this.form, data);
    },
  },
  components: {
    vSelectC: vSelect,
  },
  props: {
    trabajadores: {
      type: Array,
      required: true,
      default: () => [],
    },

    isLoadingPage: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
